import React from 'react'
import { Link } from 'react-router-dom'

// Entry point to billing history from Account Settings. The history itself is
// its own page rather than a section here, because receipts need their own
// addressable URLs — the receipt number in the address bar is the same string
// printed on the receipt.

const BillingLink = () => {
  return (
    <>
      <div className="md:col-span-1 mb-3">
        <div className="px-0 sm:px-4">
          <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-gray-100">Billing</h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
            Receipts! All (most of) the receipts!
          </p>
        </div>
      </div>

      <div className="mt-5 md:mt-0 md:col-span-2">
        <div className="shadow sm:rounded-md sm:overflow-hidden">
          <div className="px-4 py-5 bg-white dark:bg-gray-800 space-y-4 sm:p-6">
            <p className="text-sm text-gray-700 dark:text-gray-300">
              Memberships, ads, coins and tickets, with printable receipts. Anything before
              August 15th, 2026 isn't listed.
            </p>
            <Link
              to="/settings/billing"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-cccblue dark:text-white hover:opacity-90"
            >
              View billing history
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default BillingLink
